<template>
  <div class="page-container">
    <div class="behavior-grid">
      <div class="b-card">
        <div class="b-title">司机安全分排行（越高越安全）</div>
        <div ref="driverChart" class="b-chart"></div>
      </div>
      <div class="b-card">
        <div class="b-title">厂区安全分排行</div>
        <div ref="factoryChart" class="b-chart"></div>
      </div>
    </div>

    <div class="search-box">
      <el-select v-model="params.type" placeholder="事件类型" clearable style="width:150px" @change="loadEvents">
        <el-option label="超速" value="超速" />
        <el-option label="急减速" value="急减速" />
        <el-option label="急刹车" value="急刹车" />
        <el-option label="偏离路线" value="偏离路线" />
        <el-option label="疲劳驾驶" value="疲劳驾驶" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="loadEvents">查询</el-button>
    </div>

    <div class="table-box">
      <div class="b-subtitle">驾驶行为事件明细</div>
      <el-table :data="events" border v-loading="loading" empty-text="暂无事件" height="100%">
        <el-table-column prop="time" label="时间" width="160" />
        <el-table-column prop="device" label="设备" min-width="110" />
        <el-table-column prop="sn" label="SN" min-width="130" />
        <el-table-column label="事件类型" width="110">
          <template slot-scope="scope"><el-tag :type="evTag(scope.row.type)" size="mini">{{ scope.row.type }}</el-tag></template>
        </el-table-column>
        <el-table-column label="等级" width="80">
          <template slot-scope="scope"><el-tag :type="scope.row.level === 2 ? 'danger' : scope.row.level === 1 ? 'warning' : 'info'" size="mini">P{{ scope.row.level }}</el-tag></template>
        </el-table-column>
        <el-table-column prop="value" label="数值" width="110" />
        <el-table-column prop="zone" label="关联限速区" min-width="130" />
        <el-table-column prop="location" label="位置" min-width="150" />
      </el-table>
    </div>
  </div>
</template>

<script>
import { getBehaviorEvents, getSafetyRanking } from '@/api/sentinel'

export default {
  name: 'BehaviorIndex',
  data() {
    return {
      params: { type: '' },
      events: [],
      loading: false,
      charts: []
    }
  },
  mounted() {
    this.loadEvents()
    this.loadRanking()
    window.addEventListener('resize', this.resize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize)
    this.charts.forEach(c => c && c.dispose())
  },
  methods: {
    evTag(t) { return ['超速', '急刹车', '急减速'].includes(t) ? 'danger' : t === '疲劳驾驶' ? 'warning' : 'info' },
    loadEvents() {
      this.loading = true
      getBehaviorEvents(this.params).then(res => {
        if (res.code === 200) this.events = (res.data && res.data.list) || []
      }).finally(() => { this.loading = false })
    },
    loadRanking() {
      getSafetyRanking().then(res => {
        if (res.code === 200 && res.data) this.renderCharts(res.data)
      })
    },
    renderCharts(d) {
      this.charts = []
      this.charts.push(this.bar('driverChart', d.drivers.map(x => x.name), d.drivers.map(x => x.score), '#165dff', '分'))
      this.charts.push(this.bar('factoryChart', d.factories.map(x => x.name), d.factories.map(x => x.score), '#00b42a', '分'))
    },
    bar(refName, cats, series, color, unit) {
      const el = this.$refs[refName]
      if (!el) return null
      const chart = this.$echarts.init(el)
      chart.setOption({
        tooltip: { trigger: 'axis', valueFormatter: v => v + unit },
        grid: { left: 50, right: 20, top: 20, bottom: 40 },
        xAxis: { type: 'category', data: cats, axisLabel: { color: '#86909c', interval: 0, rotate: cats.length > 4 ? 30 : 0 }, axisLine: { lineStyle: { color: '#c9cdd4' } } },
        yAxis: { type: 'value', max: 100, axisLabel: { color: '#86909c' } },
        series: [{ type: 'bar', data: series, itemStyle: { color }, barWidth: '46%' }]
      })
      return chart
    },
    resize() { this.charts.forEach(c => c && c.resize()) }
  }
}
</script>

<style scoped>
.behavior-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; margin-bottom: 16px; }
.b-card { background: #fff; border-radius: 4px; box-shadow: 0 2px 12px rgba(0,0,0,.1); padding: 16px; }
.b-title { font-size: 15px; font-weight: 600; color: #1d2129; margin-bottom: 12px; }
.b-chart { width: 100%; height: 300px; }
.search-box { display: flex; align-items: center; gap: 12px; margin-bottom: 16px; }
.table-box { background: #fff; padding: 16px; border-radius: 4px; box-shadow: 0 2px 12px rgba(0,0,0,.1); }
.b-subtitle { font-size: 15px; font-weight: 600; color: #1d2129; margin-bottom: 12px; }
@media (max-width: 900px) { .behavior-grid { grid-template-columns: 1fr; } }
</style>
